import { Controller } from 'stimulus';
import { useDispatch, useHover, useThrottle } from 'stimulus-use';
import { gsap } from 'gsap';
import { isMinBreakpoint } from '../tailwindhelpers';

export default class extends Controller {
  static values = { alloweddirs: String }
  static throttles = ['moveCursor'];

  initialize() {
    this.direction = null;
  }

  connect() {
    useDispatch(this);
    useThrottle(this, { wait: 30 });
    useHover(this);
    
    this.disabled = false;

    if (isMinBreakpoint(window.innerWidth, 'md')) {
      this.createCursorEl();
    }
  }

  mouseEnter() {
    if (!this.disabled) {
      this.addCursor();
    }
  }

  mouseLeave() {
    this.removeCursor();
  }

  createCursorEl() {
    this.cursorEl = document.createElement('div');
    this.cursorEl.classList.add('cursor-arrow');
    this.cursorEl.addEventListener('click', (e) => this.sendDirection(e));
  }

  addCursor() {
    if (!this.disabled) {
      this.element.appendChild(this.cursorEl);
      this.element.addEventListener('mousemove', (e) => this.moveCursor(e));
      this.element.style.cursor = 'none';
    }
  }

  removeCursor() {
    try {
      this.element.removeChild(this.cursorEl);
    } catch (err) {

    }
    this.element.style.cursor = '';
  }

  enableCursor() {
    this.disabled = false;
    this.addCursor();
  }

  disableCursor() {
    this.disabled = true;
    this.removeCursor();
  }


  moveCursor(e) {
    console.log('move cursor');
    if (this.disabled || !isMinBreakpoint(window.innerWidth, 'md')) {
      return;
    }

    /*
    if (e.target instanceof HTMLVideoElement) {
      this.removeCursor();
      return;
    } else {
      this.addCursor();
    }
    */

    this.checkDirection(e);
    gsap.to(this.cursorEl, {
      duration: 0.1,
      left: e.pageX,
      top: e.pageY - document.querySelector('body > header').getBoundingClientRect().height,
      xPercent: -50,
      yPercent: -50,
    })
    if (typeof e.direction != 'undefined') {
      gsap.to(this.cursorEl, {
        duration: 0.1,
        rotation: e.direction.rotation,
      })
    } else if (this.direction != null) {
      gsap.to(this.cursorEl, {
        duration: 0.1,
        rotation: this.direction.rotation,
      })
    }
  }

  checkDirection(e) {
    console.log('check direction');
    const boundingClientRect = this.element.getBoundingClientRect();
    const bounds = {
      north: {
        bound: boundingClientRect.y,
        distance: Math.abs(boundingClientRect.y - e.pageY),
        rotation: '270_short'
      },
      south: {
        bound: boundingClientRect.height + boundingClientRect.y,
        distance: Math.abs(boundingClientRect.height + boundingClientRect.y - e.pageY),
        rotation: '90_short'
      },
      west: {
        bound: boundingClientRect.x,
        distance: Math.abs(boundingClientRect.x - e.pageX),
        rotation: '180_short'
      },
      east: {
        bound: boundingClientRect.width + boundingClientRect.x,
        distance: Math.abs(boundingClientRect.width + boundingClientRect.x - e.pageX),
        rotation: '0_short'
      },
    }

    let closestDistance = null;
    Object.keys(bounds).map((key, index) => {
      if (!this.alloweddirs.includes(key)) return;
      if (closestDistance == null) {
        closestDistance = {name: key, ...bounds[key]};
      } else if (bounds[key].distance < closestDistance.distance) {
        closestDistance = {name: key, ...bounds[key]};
      }
    });

    this.direction = closestDistance;
  }

  sendDirection(e) {
    if (!this.disabled && this.direction != null) {
      this.dispatch(this.direction.name, {pageX: e.pageX, pageY: e.pageY});
    }
  }

  get alloweddirs() {
    return this.alloweddirsValue.split(',');
  }

  set alloweddirs(array) {
    console.log('setting alloweddirs');
    this.alloweddirsValue = array.toString();
  }
}
